export const filterProperties = ({
  properties,
  filters,
  budgetRange,
  sizeRange,
}) => {
  let output = [...properties];

  // Availability
  if (filters.availabilityStatus) {
    output = output.filter(
      (p) => p.property?.availabilityStatus === filters.availabilityStatus
    );
  }

  // Budget Range
  if (budgetRange[0] > 100 || budgetRange[1] < 100000000) {
    const [min, max] = budgetRange;

    output = output.filter((p) => {
      const price =
        p.property?.floorPlan?.expectedPrice ||
        p.property?.expectedPrice ||
        p.property?.allowedForConstructionDetails?.expectedPrice;

      return price ? price >= min && price <= max : false;
    });
  }

  // Size Range
  if (sizeRange[0] > 10 || sizeRange[1] < 10000) {
    const [min, max] = sizeRange;

    output = output.filter((p) => {
      const area =
        p.property?.floorPlan?.carpetArea?.value ||
        p.property?.carpetArea?.value ||
        p.property?.allowedForConstructionDetails?.carpetArea?.value ||
        p.property?.allowedForConstructionDetails?.carpetArea;

      const val = typeof area === "object" ? area?.value : area;
      return val ? val >= min && val <= max : false;
    });
  }

  // Property Types
  if (filters.propertyTypes.length > 0) {
    output = output.filter((p) => {
      const type = p.property?.propertyType || p.type;
      return filters.propertyTypes.some((t) =>
        type?.toLowerCase().includes(t.toLowerCase())
      );
    });
  }

  // Bedrooms
  if (filters.bedrooms.length > 0) {
    output = output.filter((p) => {
      const bhk = p.property?.floorPlan?.bhk;
      return filters.bedrooms.some((b) => bhk && b.includes(bhk));
    });
  }

  // Furnished Status
  if (filters.furnishedStatus.length > 0) {
    output = output.filter((p) =>
      filters.furnishedStatus.includes(p.property?.furnishedStatus)
    );
  }

  // Amenities
  if (filters.amenities.length > 0) {
    output = output.filter((p) => {
      const am = p.property?.amenities || [];
      return filters.amenities.every((a) =>
        am.some((x) => x.toLowerCase().includes(a.toLowerCase()))
      );
    });
  }

  // Photos Only
  if (filters.withPhotos) {
    output = output.filter((p) => p.images?.length > 0);
  }

  // Videos Only
  if (filters.withVideos) {
    output = output.filter((p) => p.videos?.length > 0);
  }

  return output;
};
